module.exports = __webpack_public_path__ + "img/AboutMTN.20bb43a2.png";